import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import ProductCard from '../components/ProductCard';
import { Clock, Banknote, Percent, Star, Truck, ShoppingCart, Zap, Gift, Shield, Award, Flame, Heart } from 'lucide-react';

const ICON_MAP = {
  clock: Clock, banknote: Banknote, percent: Percent, star: Star,
  truck: Truck, cart: ShoppingCart, zap: Zap, gift: Gift,
  shield: Shield, award: Award, flame: Flame, heart: Heart,
};

const DEFAULT_CARDS = [
  { title: 'Entrega el mismo día', desc: 'Recibe tu pedido en 20 min a 3 horas según tu zona', icon: 'clock', gradient: 'from-orange-500 to-red-600' },
  { title: 'Pago en efectivo o transferencia', desc: 'Elige cómo prefieres pagar', icon: 'banknote', gradient: 'from-purple-600 to-pink-600' },
  { title: 'Combina y ahorra', desc: 'Lleva 3 vapes y obtén un precio especial', icon: 'percent', gradient: 'from-cyan-500 to-blue-600' },
  { title: 'Nuevos sabores cada semana', desc: 'Siempre tenemos lo último en vapes', icon: 'star', gradient: 'from-lime-400 to-emerald-600' },
];

const PromotionsPage = () => {
  const [items, setItems] = useState([]);
  const [cards, setCards] = useState(DEFAULT_CARDS);

  useEffect(() => {
    api.get('/products?sort=newest&limit=15').then((r) => setItems(r.data.items));
    api.get('/settings').then((r) => {
      const c = r.data?.promo_cards;
      if (Array.isArray(c) && c.length === 4) setCards(c);
    });
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-4 md:px-6 mt-6 pb-32">
      <h1 className="text-3xl md:text-4xl font-black text-white">Ofertas y promociones</h1>
      <p className="text-white/50 mt-1">Aprovecha nuestras ofertas seleccionadas.</p>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((p, i) => {
          const Icon = ICON_MAP[p.icon] || Star;
          return (
            <div key={i} className="relative overflow-hidden rounded-2xl border border-white/10 p-6 h-40">
              <div className={`absolute inset-0 bg-gradient-to-br ${p.gradient} opacity-80`} />
              <div className="absolute inset-0 bg-black/30" />
              <div className="relative z-10">
                <Icon className="w-8 h-8 text-white mb-2" />
                <h4 className="text-white text-lg font-black">{p.title}</h4>
                <p className="text-white/85 text-sm mt-1">{p.desc}</p>
              </div>
            </div>
          );
        })}
      </div>

      <h2 className="mt-12 text-2xl font-black text-white">Novedades</h2>
      <div className="mt-4 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {items.map((p) => <ProductCard key={p.product_id} product={p} />)}
      </div>
    </div>
  );
};

export default PromotionsPage;
